import { Navigate, Outlet } from "react-router-dom";
import { useEffect, useState } from "react";

/**
 * prtected route to check authorisation
 * @returns requested page or login if token is invalid
 */
const ProtectedRoute = () => {
  const [isAuth, setIsAuth] = useState(null);
  useEffect(() => {
    fetch("https://api.lernplattform.morph3dbot.de/api/auth", {
      credentials: "include",
    })
      .then((res) => setIsAuth(res.ok))
      .catch(() => setIsAuth(false));
  }, []);

  if (isAuth === null) return <p>Lade...</p>;

  return isAuth ? <Outlet /> : <Navigate to="/login" />;
}

export default ProtectedRoute;